import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ClearCache = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<string | null>(null);

  const prefixes = ["callRemarks_", "customerInfo_", "callDetail_"];
  const exactKeys = [
    "activeCall",
    "persist:root",
    "deviceToken",
    "os_pageViews",
    "reminderToastOptions",
  ];

  // Auto-clear exact keys and customerInfo_* on page load (no confirmation)
  useEffect(() => {
    try {
      let removed = 0;

      // Clear exact keys
      for (const k of exactKeys) {
        if (localStorage.getItem(k) !== null) {
          localStorage.removeItem(k);
          removed++;
        }
      }

      // Clear customerInfo_* keys
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("customerInfo_")) {
          localStorage.removeItem(key);
          removed++;
        }
      }

      if (removed > 0) {
        setStatus(`Automatically cleared ${removed} key(s)`);
      } else {
        setStatus(
          "No matching exact keys or customerInfo_* keys found to clear"
        );
      }
    } catch (e) {
      setStatus(`Auto-clear failed: ${String(e)}`);
    }

    // Navigate back to the previous page or fallback to home if no history
    if (window.history.length > 1) {
      navigate(-1); // Go back to previous page
    } else {
      navigate("/"); // Fallback to homepage if no history
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //   useEffect(() => {
  //     try {
  //       const storageKey = "activeCall";

  //       localStorage.setItem(
  //         storageKey,
  //         `{"id":"c965c3db-3445-4f49-9c0a-eb51c81c4147","title":"Incoming Call Ringing","createdAt":1768494772022,"meta":{"raw":{"notification":{"notificationId":"dda4aa60-f7b1-41d2-ae22-1f18a1df0333","title":"Incoming Call Ringing","body":"Ringing from +17807727555","additionalData":{"callActionInput":"2,4","callActionQueue":"Millwoods Travel Ed","callPickedByAnotherAgent":false,"caller":"+17807727555","code":"Setup","direction":"Inbound","eventData":{"event":"call_inbound"},"eventType":"call_inbound","ivrMenuName":"EDMONTON","priority":"high","sessionId":"2492186590024","timestamp":"2026-01-15T16:32:50.579Z","type":"Inbound"},"confirmDelivery":false}}}}`
  //       );
  //       let removed = 0;
  //       //   for (const k of exactKeys) {
  //       //     if (localStorage.getItem(k) !== null) {
  //       //       localStorage.removeItem(k);
  //       //       removed++;
  //       //     }
  //       //   }
  //       if (removed > 0) {
  //         setStatus(`Automatically cleared ${removed} key(s)`);
  //       } else {
  //         setStatus("No matching exact keys found to clear");
  //       }
  //     } catch (e) {
  //       setStatus(`Auto-clear failed: ${String(e)}`);
  //     }

  //     // Navigate back to the previous page or fallback to home if no history
  //     if (window.history.length > 1) {
  //       navigate(-1); // Go back to previous page
  //     } else {
  //       navigate("/"); // Fallback to homepage if no history
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, []);
  const clearSelected = () => {
    if (
      !window.confirm(
        "Clear matching localStorage keys? This cannot be undone."
      )
    )
      return;
    try {
      const toRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;
        if (exactKeys.includes(key)) {
          toRemove.push(key);
          continue;
        }
        for (const p of prefixes) {
          if (key.startsWith(p)) {
            toRemove.push(key);
            break;
          }
        }
      }
      toRemove.forEach((k) => localStorage.removeItem(k));
      setStatus(`Cleared ${toRemove.length} matching key(s)`);

      // Navigate to '/' after clearing
      navigate("/");
    } catch (e) {
      setStatus(`Failed: ${String(e)}`);
    }
  };

  const clearAll = () => {
    if (
      !window.confirm(
        "Clear all localStorage? This will remove all stored data."
      )
    )
      return;
    try {
      localStorage.clear();
      setStatus("Cleared all localStorage keys");

      // Navigate to '/' after clearing
      navigate("/");
    } catch (e) {
      setStatus(`Failed: ${String(e)}`);
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-xl font-semibold mb-4">Clear Local Cache</h2>
      <p className="text-sm text-gray-600 mb-4">
        This tool clears debugging. You can clear only the common cache keys or
        clear all storage.
      </p>

      <div className="mb-4">
        <div className="mb-2 font-medium">Will clear (matching):</div>
      </div>

      <div className="flex gap-3">
        <button
          className="bg-red-800 text-white px-4 py-2 rounded"
          onClick={clearAll}
        >
          Clear All
        </button>
        <button
          className="bg-gray-200 px-4 py-2 rounded"
          onClick={() => navigate(-1)}
        >
          Sign In
        </button>
      </div>

      {status && <div className="mt-4 text-sm">{status}</div>}
    </div>
  );
};

export default ClearCache;
